import { defineMessages, useIntl } from "react-intl";
import { classNames } from "@ct-react/core";
import { useLocaleNavigate } from "@ct-react/locale";
import { Wrapper } from "../layout/wrapper";
import Button from "../common/button";
import RatioImage from "../medias/ratio-image";
import estimatePath from "../../assets/home/estimate.jpg";
import "./estimate.scss";


const transDefs = defineMessages({
  sub: { id: "homepage.estimate.sub-title", defaultMessage: "Estimation immobilière" },
  title: { id: "homepage.estimate.title", defaultMessage: "Vous souhaitez connaître la valeur réelle de votre chalet ou de votre appartement ?" },
  body: { id: "homepage.estimate.body", defaultMessage: "EV Real Estate & Services met à votre disposition son expertise et sa parfaite connaissance du marché immobilier des 4 Vallées pour vous proposer une estimation fiable et personnalisée. Remplissez notre formulaire d’estimation en ligne et recevez une évaluation gratuite de votre bien." },
  button: { id: "homepage.estimate.button", defaultMessage: "Faire estimer mon bien" }
});

const EstimatePart = ({ className }: { className?: string }) => {

  const intl = useIntl();
  const navigate = useLocaleNavigate();

  const wrapperClasses = classNames("estimate-part", "content", className);

  return (
    <section className={wrapperClasses}>
      <Wrapper.Centered className="content">
        <div className="two-col">

          <div className="media">
            <RatioImage source={estimatePath} />
          </div>

          <div className="text">
            <span className="sub">
              {intl.formatMessage(transDefs.sub)}
            </span>
            <h2>{intl.formatMessage(transDefs.title)}</h2>
            <p>{intl.formatMessage(transDefs.body)}</p>
            <Button className="link white"
                    onClick={() => navigate("/with-us/estimate/")}>
              {intl.formatMessage(transDefs.button)}
            </Button>
          </div>

        </div>
      </Wrapper.Centered>
    </section>);

}

export default EstimatePart;
